import * as React from 'react';
import { FormEvent } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Link2 } from 'lucide-react';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';

import {
  useSavePortfolioLinkMutation,
  useGetPortfolioLinkQuery,
} from '../store/portfolioApi';
import { toast } from 'sonner';

const AddPortfolioForm = () => {
  const [portfolioLink, setPortfolioLink] = React.useState('');
  const { user } = useSelector((state: RootState) => state.user);
  const [savePortfolioLink] = useSavePortfolioLinkMutation();
  const { refetch } = useGetPortfolioLinkQuery(user?._id);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await savePortfolioLink({
        token: user?.token,
        data: { portfolio: portfolioLink },
      });
      toast.success('Portfolio link submitted successfully!');
    } catch (error) {
      toast.error(
        (error )?.message ||
          'Try checking a different link; it could already exist.'
      );
    }
    refetch();
  };

  return (
    <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8">
      <div className="max-w-4xl mx-auto">
        {/* Breadcrumb */}
        <nav className="flex items-center space-x-2 mb-6 text-sm text-muted-foreground">
          <span className="hover:text-gray-900">Dashboard</span>
          <span>/</span>
          <span className="text-muted-foreground">Portfolio</span>
        </nav>

        <Card className="">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-gray-900">
              <h1 className="text-foreground">Add Portfolio</h1>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="portfolioLink" className="text-base">
                  Enter Your Portfolio Link{' '}
                  <span className="text-red-500">*</span>
                </Label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                    <Link2 className="h-5 w-5 text-gray-400" />
                  </div>
                  <Input
                    id="portfolioLink"
                    type="url"
                    placeholder="Enter Your Portfolio Link"
                    className="pl-10"
                    value={portfolioLink}
                    onChange={(e) => setPortfolioLink(e.target.value)}
                    required
                  />
                </div>
              </div>

              <Button
                type="submit"
                className="w-full sm:w-auto px-8 bg-green-600 hover:bg-green-700 text-white"
              >
                Submit
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AddPortfolioForm;

// import React, { FormEvent } from "react";
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// import { Input } from "@/components/ui/input";
// import { Button } from "@/components/ui/button";
// import { Label } from "@/components/ui/label";
// import { Link2 } from "lucide-react";
// import { useSelector } from "react-redux";
// import { RootState } from "@/types";

// import { useSavePortfolioLinkMutation } from "../store/portfolioApi";
// import { toast } from "sonner";

// const AddPortfolioForm = () => {
//   const [portfolioLink, setPortfolioLink] = React.useState("");
//   const { user } = useSelector((state: RootState) => state.user);
//   const [savePortfolioLink, { isLoading }] = useSavePortfolioLinkMutation();

//   const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
//     e.preventDefault();

//     if (!portfolioLink.trim()) {
//       toast.error("Portfolio link cannot be empty!");
//       return;
//     }

//     try {
//       const res = await savePortfolioLink({
//         token: user?.token,
//         data: { portfolio: portfolioLink },
//       }).unwrap(); // Ensures error handling at the API level

//       toast.success("Portfolio submitted successfully!");
//       setPortfolioLink(""); // Clear input after success
//     } catch (err: any) {
//       console.error("Submission error:", err);

//       let errorMessage = "An unexpected error occurred. Please try again.";

//       if (err?.data?.message) {
//         errorMessage = err.data.message; // API error message
//       } else if (err?.status === 400) {
//         errorMessage = "Invalid link. Please check the format.";
//       } else if (err?.status === 409) {
//         errorMessage = "This portfolio link already exists!";
//       } else if (err?.status === 401) {
//         errorMessage = "Unauthorized! Please log in again.";
//       }

//       toast.error(errorMessage);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8">
//       <div className="max-w-4xl mx-auto">
//         {/* Breadcrumb */}
//         <nav className="flex items-center space-x-2 mb-6 text-sm text-muted-foreground">
//           <span className="hover:text-gray-900">Dashboard</span>
//           <span>/</span>
//           <span className="text-muted-foreground">Portfolio</span>
//         </nav>

//         <Card>
//           <CardHeader>
//             <CardTitle className="text-2xl font-bold text-gray-900">
//               <h1 className="text-foreground">Add Portfolio</h1>
//             </CardTitle>
//           </CardHeader>
//           <CardContent>
//             <form onSubmit={handleSubmit} className="space-y-6">
//               <div className="space-y-2">
//                 <Label htmlFor="portfolioLink" className="text-base">
//                   Enter Your Portfolio Link{" "}
//                   <span className="text-red-500">*</span>
//                 </Label>
//                 <div className="relative">
//                   <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
//                     <Link2 className="h-5 w-5 text-gray-400" />
//                   </div>
//                   <Input
//                     id="portfolioLink"
//                     type="url"
//                     placeholder="Enter Your Portfolio Link"
//                     className="pl-10"
//                     value={portfolioLink}
//                     onChange={(e) => setPortfolioLink(e.target.value)}
//                     required
//                   />
//                 </div>
//               </div>

//               <Button
//                 type="submit"
//                 className="w-full sm:w-auto px-8 bg-green-600 hover:bg-green-700 text-white"
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Submitting..." : "Submit"}
//               </Button>
//             </form>
//           </CardContent>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default AddPortfolioForm;
